import {getFormSubmissionIpAddress} from '@/api/api';
import {useEffect, useState} from 'react';

export const useFormSubmissionIpAddress = () => {
  const [ipAddress, setIpAddress] = useState<string | null>(null);

  useEffect(() => {
    getFormSubmissionIpAddress()
      .then((ip) => {
        setIpAddress(ip || null);
      })
      .catch(() => setIpAddress(null));
  }, []);

  return ipAddress;
};
